export enum BadgeStyle {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Secondary = 'secondary',
  Primary = 'primary',
  Info = 'info'
}
